
import { format } from 'date-fns'
import SuccessStory from '~/components/SuccessStory.vue'

export default {
  components: { SuccessStory },
  async asyncData({ $prismic, params, error }) {
    try {
      const document = await $prismic.api.getByUID('success_story', params.slug)

      const prevSuccessStory = (
        await $prismic.api.query('[at(document.type, "success_story")]', {
          pageSize: 1,
          after: `${document.id}`,
          orderings: '[document.last_publication_date desc]',
        })
      ).results[0]

      const nextSuccessStory = (
        await $prismic.api.query('[at(document.type, "success_story")]', {
          pageSize: 1,
          after: `${document.id}`,
          orderings: '[document.last_publication_date]',
        })
      ).results[0]

      return {
        document,
        prevSuccessStory,
        nextSuccessStory,
      }
    } catch (e) {
      error({ statusCode: 404, message: 'Page not found' })
    }
  },

  head() {
    const roleTitle = this.document.data.role_title?.[0]?.text || ''
    const companyName = this.document.data.company_name?.[0]?.text || ''
    const location = this.document.data.location?.[0]?.text || ''

    return {
      title:
        this.document.data.meta_title ||
        `${roleTitle} at ${companyName}, ${location} | Nurole case study`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            this.document.data.meta_description ||
            `Nurole case study detailing the successful placement of a ${roleTitle} at ${companyName} in ${location}`,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content:
            this.document.data.meta_description ||
            `Nurole case study detailing the successful placement of a ${roleTitle} at ${companyName} in ${location}`,
        },
      ],
    }
  },

  computed: {
    date() {
      return format(new Date(this.document.last_publication_date), 'PP')
    },

    fullUrl() {
      return this.encodeURI(`https://www.nurole.com${this.$route.path}`)
    },

    title() {
      return this.encodeURI(this.document.data.title)
    },

    shareFacebook() {
      const imageUrl = this.encodeURI(this.document.data.company_logo.url)
      const summary = this.encodeURI(this.document.data.subtitle || '')
      return `http://www.facebook.com/sharer/sharer.php?u=${this.fullUrl}&picture=${imageUrl}&title=${this.title}&description=${summary}&caption=Nurole`
    },

    shareTwitter() {
      return `https://twitter.com/intent/tweet?url=${this.fullUrl}&via=NuroleCom&text=${this.title}`
    },

    shareLinkedin() {
      const imageUrl = this.encodeURI(this.document.data.company_logo.url)
      const title = this.encodeURI(
        this.document.data.company_name[0].text.slice(0, 200)
      )
      const summary = this.encodeURI(this.document.data.role_title[0].text)

      return `https://www.linkedin.com/shareArticle?url=${this.fullUrl}&image_url=https:${imageUrl}&mini=true&title=${title}&summary=${summary}&source=Nurole`
    },

    shareEmail() {
      return `mailto:?body=${this.fullUrl}&subject=${this.title}`
    },
  },

  methods: {
    encodeURI(url) {
      return encodeURIComponent(url)
    },

    sharePrint() {
      if (window.print) window.print()
    },
  },
}
